<template>
  <div class="col clan-card create-team-card">
    <Avatar
      class="clan-card_avatar"
      type="clan"
      :img-url="require(`@/assets/images/team/create-team.svg`)"
      :size="80"
    />
    <Button
      class="btn-primary"
      @click.prevent.stop="goToClanCreate(currentTournament)"
    >
      {{ $t('_web_single_action_create-team', 'Create team') }}
    </Button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Avatar from '@/components/images/Avatar';
import Button from '@/components/atoms/HeraFormBtn';
import joinAction from '@/views/tournaments/mixins/joinTournamentAction';

export default {
  components: { Avatar, Button },
  mixins: [joinAction],
  computed: { ...mapGetters(['currentTournament']) },
};
</script>

<style lang="scss" scoped>
.team-selection-tour {
  .clan-card.create-team-card {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
  }
}
</style>
